// import { object, string, number, array } from 'yup';

import useCredentials from 'api/hook/useCredentials';

import { baseAxios, handleError } from 'api';
import { useQuery } from '@tanstack/react-query';

export function useReport(start, end, isUser, isAdmin) {
  const authAxios = useCredentials();
  const params = new URLSearchParams({ start, end, isUser, isAdmin });

  return useQuery({
    queryKey: ['admin/report', 'order', start, end, isUser, isAdmin],
    queryFn: () =>
      baseAxios(authAxios, {
        url: `admin/report?${params}`,
      }),
    onError: handleError,
    initialData: [],
    enabled: false,
    retry: 0,
  });
}
